import { render } from "./dse_dashboard.vue?vue&type=template&id=6885fad0&scoped=true&ts=true"
import script from "./dse_dashboard.vue?vue&type=script&lang=ts"
export * from "./dse_dashboard.vue?vue&type=script&lang=ts"

import "./dse_dashboard.vue?vue&type=style&index=0&id=6885fad0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6885fad0"]])

export default __exports__